export default __webpack_public_path__ + "/dist/images/logo5.jpg";